import React, { forwardRef } from "react";
const SvgClose = (props, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 5 5 19M5 5l14 14", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
